// extracted by mini-css-extract-plugin
module.exports = {"form":"PostRanking_form__2as46","input":"PostRanking_input__1AoXs","formDiv":"PostRanking_formDiv__291kB","thankYou":"PostRanking_thankYou__3nLOl"};